module.exports = __webpack_public_path__ + "img/company-6.01f120f9.png";